import { ADJUSTED_RESIDUAL_VALUE_TESTID, useAdjustedResidualDisplayValue } from '@makemydeal/dr-dash-components';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const AdjResidualDisplayRow = () => {
    const { label, value, prefix } = useAdjustedResidualDisplayValue();

    return (
        <ReadOnlyValueRow
            rowKey="adjResidual"
            label={label}
            value={`${prefix}${value}`}
            valueTestId={ADJUSTED_RESIDUAL_VALUE_TESTID}
        />
    );
};
